import { PayloadAction, createSlice } from "@reduxjs/toolkit";

// Stores the active ambulance trip (hospital-service) for the currently open ticket.
// One doc at a time — same pattern as ticketSlice.
// Not persisted (blacklisted in store.js); re-fetched on ticket load.

const initialState: {
  isLoading: boolean;
  tripData: any | null;
  isError: boolean;
} = {
  isLoading: false,
  tripData: null,
  isError: false,
};

const ambulanceTripSlice = createSlice({
  name: "ambulanceTrip",
  initialState,
  reducers: {
    ambulanceTripStart: (state) => {
      state.isLoading = true;
      state.isError = false;
    },
    setAmbulanceTripData: (state, action: PayloadAction<any>) => {
      state.isLoading = false;
      state.isError = false;
      state.tripData = action.payload;
    },
    updateAmbulanceTripFields: (state, action: PayloadAction<Partial<any>>) => {
      if (state.tripData) {
        state.tripData = { ...state.tripData, ...action.payload };
      }
    },
    clearAmbulanceTripData: (state) => {
      state.isLoading = false;
      state.isError = false;
      state.tripData = null;
    },
    ambulanceTripFailure: (state) => {
      state.isLoading = false;
      state.isError = true;
    },
  },
});

export const {
  ambulanceTripStart,
  setAmbulanceTripData,
  updateAmbulanceTripFields,
  clearAmbulanceTripData,
  ambulanceTripFailure,
} = ambulanceTripSlice.actions;

export default ambulanceTripSlice.reducer;
